import { lazy } from "react";
import { Outlet } from "react-router-dom";
import { IssuerGuard } from "src/guards/issuer-guard";
import { Layout as AuthLayout } from "src/layouts/auth/layout";
import { Issuer } from "src/utils/auth";

const IndexPage = lazy(() => import("src/pages/auth/index"));
const LoginPage = lazy(() => import("src/pages/auth/login"));
const RegisterPage = lazy(() => import("src/pages/auth/register"));
const ResetPasswordPage = lazy(() => import("src/pages/auth/reset-password"));

export const authRoutes = [
  {
    path: "auth",
    element: (
      <IssuerGuard issuer={Issuer.JWT}>
        <AuthLayout>
          <Outlet />
        </AuthLayout>
      </IssuerGuard>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        path: "reset-password",
        element: <ResetPasswordPage />,
      },
    ],
  },
];
